import { API_NAME, DEFAULT_ERROR_MESSAGE } from '../../const';
import API from '@aws-amplify/api'
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

interface Condition {
  policyNumber: string | null;
  name: string | null;
  nameKana: string | null;
  applyIds: string[];
  createdAtFromByValue: string | null;
  createdAtToByValue: string | null;
  searchTabType: string;
  responseStatuses: string[];
  necessaryChangeTypes: string[];
  allowedChangeTypes: string[];
  isIdentifiedAll: string;
  feeCategory: string | null;
  cancellationCategory: string | null;
  existsCallDesignated: string;
  isSmsSendingRequired: string;
  lineChatAvailability: string | null;
}
interface UpdateAppliesResponse {
  status: string;
  data: {
    numberOfRecordsUpdated: number;
  };
}

export async function search(condition: Condition, query: any): Promise<any> {
  await checkCurrentAuthenticatedUser()
  const response = await API
    .get(API_NAME, `/v2`, {
      queryStringParameters: {
        policy_number: condition.policyNumber,
        name: condition.name,
        name_kana: condition.nameKana,
        apply_ids: condition.applyIds.length > 0 ? condition.applyIds : null,
        search_tab_type: condition.searchTabType,
        created_at_from: condition.createdAtFromByValue,
        created_at_to: condition.createdAtToByValue,
        response_statuses: condition.responseStatuses.length > 0 ? condition.responseStatuses : null,
        necessary_change_types: condition.necessaryChangeTypes.length > 0 ? condition.necessaryChangeTypes : null,
        allowed_change_types: condition.allowedChangeTypes.length > 0 ? condition.allowedChangeTypes : null,
        is_identified_all: condition.isIdentifiedAll,
        fee_category: condition.feeCategory,
        cancellation_category: condition.cancellationCategory,
        exists_call_designated: condition.existsCallDesignated,
        is_sms_sending_required: condition.isSmsSendingRequired,
        line_chat_availability: condition.lineChatAvailability,
        page_size: query.pageSize,
        page: query.page,
        order_by: query.orderBy.field,
        order_direction: query.orderDirection,
      },
    })
    .catch((err) => {
      alert(DEFAULT_ERROR_MESSAGE);
      throw err;
    });
  return response;
}

export async function updateAppliesStatusCompleted(
  apply_ids: []
): Promise<UpdateAppliesResponse> {
  await checkCurrentAuthenticatedUser()
  const response = await API
    .put(API_NAME, `/v2/status/completed`, {
      body: {
        apply_ids: apply_ids,
      }
    })
    .catch((err) => {
      alert(DEFAULT_ERROR_MESSAGE);
      throw err;
    });
  return response;
}

export async function addTodayCallHistory(
  apply_ids: []
): Promise<UpdateAppliesResponse> {
  await checkCurrentAuthenticatedUser()
  const response = await API
    .post(API_NAME, `/v2/call-history/today`, {
      body: {
        apply_ids: apply_ids,
      }
    })
    .catch((err) => {
      alert(DEFAULT_ERROR_MESSAGE);
      throw err;
    });
  return response;
}
